import { useCallback, useState } from 'react';

export interface AsyncActionState<T> {
  data?: T;
  loading?: boolean;
  error?: unknown;
}

export function useAsyncAction<T>(
  action: () => Promise<T | undefined>,
  dependencies: unknown[] = []
) {
  const [state, setState] = useState<AsyncActionState<T>>({ loading: false });

  const perform = useCallback(() => {
    setState({ loading: true });

    (async () => {
      try {
        const data = await action();
        setState({ data, loading: false });
      } catch (error) {
        setState({ error, loading: false });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [action, ...dependencies]);

  return { ...state, perform };
}
